// src/components/Gallery/GalleryPage.js
import React, { useState, useRef } from 'react';
import { portfolioSections, getAllArtworks } from '../../data/portfolioData';
import CategoryNavigation from './CategoryNavigation';
import PaintingsLayout from './PaintingsLayout';
import MinimalLayout from './MinimalLayout';
import BackToTop from './BackToTop';
import LightboxModal from './Lightbox/LightboxModal';
import '../../styles/Gallery.css';

export default function PortfolioGallery() {
  const [selectedCategory, setSelectedCategory] = useState('paintings');
  const [selectedImageIndex, setSelectedImageIndex] = useState(null);
  const galleryRef = useRef(null);

  // Get current sections and all artworks
  const currentSections = portfolioSections[selectedCategory];
  const allArtworks = getAllArtworks();

  // Handle image click to open lightbox
  const handleImageClick = (artwork) => {
    const globalIndex = allArtworks.findIndex(img => img.id === artwork.id);
    setSelectedImageIndex(globalIndex);
  };

  // Lightbox navigation handlers
  const handleNext = () => {
    setSelectedImageIndex((prev) => (prev + 1) % allArtworks.length);
  };

  const handlePrev = () => {
    setSelectedImageIndex((prev) => (prev - 1 + allArtworks.length) % allArtworks.length);
  };

  const handleClose = () => {
    setSelectedImageIndex(null);
  };

  // Category change handler
  const handleCategoryChange = (category) => {
    setSelectedCategory(category);
    // Scroll to top when changing categories
    if (galleryRef.current) {
      galleryRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="portfolio-gallery-container" ref={galleryRef}>
        
        {/* Category Navigation */}
        <CategoryNavigation 
          selectedCategory={selectedCategory}
          onCategoryChange={handleCategoryChange}
        />

        {/* Main Gallery Content */}
        {selectedCategory === 'paintings' ? (
          <PaintingsLayout 
            sections={currentSections}
            onImageClick={handleImageClick}
          />
        ) : (
          <MinimalLayout 
            sections={currentSections}
            onImageClick={handleImageClick}
          />
        )}

        {/* Lightbox Modal */}
        {selectedImageIndex !== null && (
          <LightboxModal 
            imageIndex={selectedImageIndex}
            allArtworks={allArtworks}
            onClose={handleClose}
            onNext={handleNext}
            onPrev={handlePrev}
          />
        )}

        <BackToTop />
      </div>
    </div>
  );
}